import cardStyles from './card-containers/cards-container.module.css';

const COLUMN_WIDTH = parseInt(cardStyles.columnWidth, 10);

export function calculateBoardWidth(stageCount: number): number {
    return stageCount * COLUMN_WIDTH + 8 * (stageCount - 1); // account for gaps between
}
